import { ActionItemStatusData } from './action-item-status-data';
import { ActionItemsCriteriaData } from './action-item-criteria-data';

export interface ActionItemsFilterCriteriaData {
  actionItemCriteria: ActionItemsCriteriaData;
  actionItemStatuses: ActionItemStatusData;
}
